"use strict";
// Copyright © Veeam Software Group GmbH
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Popup = void 0;
const react_1 = __importDefault(require("react"));
const styled_components_1 = __importStar(require("styled-components"));
const WindowClose_1 = require("../controls/WindowClose");
const helpers_1 = require("../helpers");
const Overlay_1 = require("../Overlay");
const StackView_1 = require("../StackView");
const BodyWrapper = styled_components_1.default.div `
    height: 100%;
    overflow-y: auto;
`;
const ActionsWrapper = styled_components_1.default.div ``;
const ContentWrapper = (0, styled_components_1.default)(StackView_1.StackView) `
    margin-top: ${helpers_1.SPACING_XL};
    padding: 0 ${helpers_1.SPACING_M} ${helpers_1.SPACING_M} ${helpers_1.SPACING_M};
    width: 100%;
`;
const PopupWindow = (0, styled_components_1.default)(StackView_1.StackView) `
    position: relative;
    box-shadow: 2px 2px 5px rgba(0, 0, 0, 0.25);
    min-width: min-content;
    max-width: 1200px;
    max-height: 800px;

    ${({ width, height, theme }) => (0, styled_components_1.css) `
        background-color: ${theme.colorBackgroundBlank};
        width: ${width};
        height: ${height};
    `}
`;
const DEFAULT_SIZE = {
    width: '600px',
    height: '488px'
};
exports.Popup = (0, helpers_1.createUIElement)('Popup', (_a, ref) => {
    var { className, onRequestClose, canClose = true, body, actions, width = 'auto', height = 'auto', onClick, onMouseDown, onMouseUp, onMouseEnter, onMouseLeave, onKeyDown, onKeyUp, onKeyPress, style } = _a, rest = __rest(_a, ["className", "onRequestClose", "canClose", "body", "actions", "width", "height", "onClick", "onMouseDown", "onMouseUp", "onMouseEnter", "onMouseLeave", "onKeyDown", "onKeyUp", "onKeyPress", "style"]);
    const dataSelectorId = rest['data-selector-id'] || 'popup';
    return (react_1.default.createElement(Overlay_1.Overlay, Object.assign({}, rest, { "data-selector-id": dataSelectorId, className: `vm-Popup ${className}`, fixed: true, view: Overlay_1.OVERLAY_VIEW.tone, contentMod: Overlay_1.OVERLAY_CONTENT_MOD.center, onClick: onClick, onMouseDown: onMouseDown, onMouseUp: onMouseUp, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, onKeyDown: onKeyDown, onKeyUp: onKeyUp, onKeyPress: onKeyPress, ref: ref, style: style }),
        react_1.default.createElement(PopupWindow, { width: width === 'auto' ? DEFAULT_SIZE.width : width, height: height === 'auto' ? DEFAULT_SIZE.height : height, style: style },
            canClose && (react_1.default.createElement(WindowClose_1.WindowClose, { "data-selector-id": `${dataSelectorId}-close-control`, onClick: onRequestClose })),
            react_1.default.createElement(ContentWrapper, { gap: StackView_1.STACK_GAP.m, direction: StackView_1.STACK_DIRECTION.column },
                react_1.default.createElement(BodyWrapper, null, body),
                actions && react_1.default.createElement(ActionsWrapper, null, actions)))));
});
//# sourceMappingURL=Popup.js.map